import IconCertificate from './component.jsx'
export default IconCertificate
